export const alarmSoundState = {
    errorCode : 0,
    statusCode : 0,
    alarmSoundList : [],
    message: '',
    updatedValue : '',
    isLoading : false
}